import {FILTERS_OPTIONS as sharedFiltersOptions} from '../common/filtersOptions.js'

// Define only the filters options that are different from the common ones
export const FILTERS_OPTIONS = {...sharedFiltersOptions}
